<template name="visitorLists">
  <div class="visitorList">
    <div>
      <div>
        <visitorDetailList ref="visitorDataList"
        :inviteStatus = "1"
        :inviteId = "this.inviteId"
        :isTicket = "this.isOwner"
        :isCheckOwner = "this.isCheckOwner"
        :areaName="areaName"
        :areaAddress="areaAddress"
        @popupStatus="changeStatus"
        @popupTip="popupTipModal"
        @popupGmModal="popupGmModal"
        @approveAllListModal="approveAllListModal"
        @approveAllModal="approveAllListModal"
        @showLookImgs="showLookImgs" @editModalShow="editModalShow" @closeEditModal="closeEditModal"@addVisitor="emitAddEventToParentScope"
        @showAlertModal="showAlertModal"></visitorDetailList>
      </div>
    </div>
    <div class="traning-course">
      <traningCourse ref="trainingCourse"></traningCourse>
    </div>
  </div>
</template>

<script type="text/javascript">
  import visitorDetailList from '@/views/external/visitorList.vue';
  import TraningCourse from '@/views/external/trainingCourse.vue';
  export default {
    name: 'visitorLists',
    components: {
      visitorDetailList,
      TraningCourse,
    },
    props: {
      inviteId: String,
      areaName: String,
      areaAddress: String,
    },
    data() {
      return {
        detailLists: [],
        isOwner: false,
        isCheckOwner: false,
        visitorMaterial: 0,
        showAddInvisitor: false,
      }
    },
    methods: {
      loadData(data, endDay, canAddOthersMaterial, canAddMaterial, topdetail) {
        if (data) {
          this.detailLists = data;
          // console.log(this.detailLists);
          this.$refs.visitorDataList.getData(this.detailLists,endDay, canAddOthersMaterial, canAddMaterial,topdetail);
          this.$refs.visitorDataList.hideVisitor(this.detailLists,0,0);
        }
      },
      loadLesson(lessData) {
        this.$refs.trainingCourse.loadData(lessData);
      },
      changeStatus() {

      },
      popupTipModal() {

      },
      popupGmModal() {

      },
      approveAllListModal() {

      },
      showLookImgs() {

      },
      editModalShow(status) {
        this.$emit("editModalShow", status);
      },
      closeEditModal(status) {
        this.$emit('closeEditModal', status);
      },
      emitAddEventToParentScope(canAddOthersMaterial, canAddMaterial) {
      	this.$emit('addVisitor', canAddOthersMaterial, canAddMaterial);
      },
      showAlertModal(status, data) {
        this.$emit('showAlertModal', status, data);
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "../../scss/variables.scss";
.visitorList {
  width: 100%;
}
.addBtn {
  width: 317px;
  height: 46px;
  margin-left: 0;
  @include respond-to('sm-max') {
    display: block;
    width: 100%;
    padding: 20px 29px 0;
    margin-left: 0;
  }
   @include respond-to('ml') {
    display: block;
    width: 100%;
    padding: 20px 29px 0;
    margin-left: 0;
  }
  .addInformation {
    width: 100%;
    margin: 20px auto 0;
    background-image: linear-gradient(81deg, #f36443, #e42029);
    height: 46px;
    text-align: center;
    color: #fff;
    line-height: 46px;
    border-radius: 5px;
    margin-top: 0px;
    cursor: pointer;
    i {
      margin-right: 7px;
    }
    span {
      font-size: 15px;
      font-weight: 600;
      color: #fff;
    }
  }
}
.traning-course {
  width: 100%;
  overflow-x: hidden;
  box-shadow: 0 0 15px rgba(100, 100, 100, 0.1);
  border-radius: 10px;
  .row {
    margin: 0;
  }
}
</style>
